<template>
	<div >
		<trainSearch title="平台简介"></trainSearch>
		<div class="container">
			<div style="display: flex;flex-direction: column;width: 17.8125rem;height: 3.75rem;margin: 0 1.25rem">
				<!-- <div @click="selectedItem=1" :class="selectedItem==1?'selectedItem':''" style="cursor: pointer; background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					中心简介
				</div>
				<div @click="selectedItem=2" :class="selectedItem==2?'selectedItem':''" style=" cursor: pointer;background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					许可证明
				</div>
				<div @click="selectedItem=3" :class="selectedItem==3?'selectedItem':''" style="cursor: pointer;background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					联系我们
				</div> -->
				<div v-for="(item,index) in profileData" :key="index" @click="selectedItem=index" :class="selectedItem==index?'selectedItem profileHover':'profileHover'" style="cursor: pointer; background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
				height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin-bottom:0.6525rem;">
									{{item.title}}
								</div>
			</div>
			<!-- <div v-if="selectedItem==1" style="width: 892px;
			height: 1516px;background: #FFFFFF;
border-radius: 4px;">
				<richText title="中心简介" :msg="centerMsg"></richText>
			</div>
			<div v-if="selectedItem==2" style="width: 892px;
						height: 1516px;background: #FFFFFF;
			border-radius: 4px;">
				<richText title="许可证明" :msg="centerMsg"></richText>

			</div>
			<div v-if="selectedItem==3" style="width: 892px;
									height: 1516px;background: #FFFFFF;
						border-radius: 4px;">
				<richText title="联系我们" :msg="centerMsg"></richText>

			</div> -->
			<div v-for="(item,index) in profileData" v-if="selectedItem==index" style="width: 892px;
						background: #FFFFFF;
			border-radius: 4px;box-shadow: 0 0.525rem 0.5625rem 0.3125rem rgba(129, 129, 129,0.1);">
							<richText :title="item.tag" :msg="item.content"></richText>
						</div>
		</div>

	</div>

</template>

<script>
	import {Dynamic} from '@/api/index.js'
	import trainSearch from '../../components/trainSearch.vue'
	import richText from '../../components/richText.vue'
	export default {
		name:'/centerProfile',
		components: {
			trainSearch,
			richText
		},
		data() {
			return {
				profileData:[],
				selectedItem: 0,
				centerMsg: '',
				Dynamic
			}
		},
		created(){
			this.getProfileData()
		},
		methods:{
			async getProfileData(){
				let profileData = await Dynamic({type: 0,page: 1,row: 10000 ,name:""})
				this.profileData= profileData.data.data
				console.log(profileData)
			}
		}
	}
</script>

<style scoped>
	.container {
		width: 100%;
		display: flex;
		background-color: #F6F8FA;
		height: 100%;
		min-height: 37.5rem;
		justify-content: center;
		padding-top: 3.75rem;
		padding-bottom: 4.6875rem;
	}

	.selectedItem {
		background: #1890FF !important;
		color: white;
	}
	
</style>
<style>
	.profileHover:hover{
		/* background: rgba(24, 144, 255,0.9) !important;
		color: white; */
		box-shadow: 0 0.125rem 0.5625rem 0.3125rem rgba(39, 143, 255, 0.5);
		transform: scale(1.01);
		
	}
</style>
